export const checkCosmosInstallation = async () => {
  if (process.env.REACT_APP_TARGET_ENV === "development") {
    return true;
  }

  const url =
    "/rest/atlassian-connect/1/addons/com.caelor.confluence.cloud.cosmos";
  try {
    const response = await window.AP.request(url);
    const data = JSON.parse(response.body);
    return data && data.state === "ENABLED";
  } catch (e) {
    // If accessing anonymously
    if (e?.xhr?.status === 401) {
      return true;
    }
    return false;
  }
};
